import { useMemo } from "react";
import { faAnglesUpDown } from "@fortawesome/pro-regular-svg-icons";

import useActiveMembership from "core/hooks/useActiveMembership";
import useCurrentUser from "core/hooks/useCurrentUser";
import Combobox from "core/components/Field/Combobox";
import Typography from "core/components/Typography";

const ActiveMembershipSwitcher = () => {
  const { currentUser } = useCurrentUser();
  const { activeMembership, switchActiveMembership } = useActiveMembership();

  const { data, options } = useMemo(() => {
    return {
      data: currentUser.memberships,
      options: currentUser.memberships.map((m) => {
        return {
          value: m.organization_id,
          label: m.organization_name,
        };
      }),
    };
  }, [currentUser.memberships]);

  const handleChange = (orgId) => {
    const membership = data.find((m) => m.organization_id === orgId);

    switchActiveMembership(membership);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        minWidth: "150px",
      }}
    >
      <Combobox
        id="activeMembershipSwitcher"
        name="activeMembershipSwitcher"
        size="large"
        options={options}
        value={activeMembership.id}
        onChange={handleChange}
        hideBuiltInFieldError
        icons={{
          openMenu: faAnglesUpDown,
        }}
        formatOptionLabel={(data, formatOptionLabelMeta) => {
          const orgId = data.value;
          const orgName = data.label;

          return (
            <div>
              <Typography variant="h6" noMargin>
                {orgName}
              </Typography>
              <Typography variant="sub-text" noMargin>
                ID: {orgId}
              </Typography>
            </div>
          );
        }}
      />
    </div>
  );
};

export default ActiveMembershipSwitcher;
